import React, {Component} from 'react'
import {connect} from 'react-redux'
import {bindActionCreators} from "redux";
import SostaOnlineApiService from '../../../services/SostaOnlineApiService'
import PaymentResult from "./PaymentResult";
import queryString from 'query-string'
import Loading from "../../../components/LoadingComponent";
import moment from 'moment';

const mapStateToProps = (state) => {
  return {};
};

const mapDispatchToProps = (dispatch) => {
  return {};
};

class PaymentResultContainer extends Component {
    
  constructor(props) {
    super(props);    

    this.state = {
      paymentResult: {},
      loading: false,
      error: null
    };
  }

  async componentDidMount() {

    let iuv = localStorage.getItem("iuvdata")
    console.log('iuv: ' + iuv);

    this.setState({loading: true});
    
    console.log("containers/UserArea/Checkout/PaymentResultContainer: this.props.location.search" , this.props.location.search);
    
    const parsed  = queryString.parse(this.props.location.search);
    const pathname = this.props.location.pathname     
    const payment = await SostaOnlineApiService.getPaymentConfig();

    console.log('payment: ' , payment);
    

    let typePayment = "";

    if (pathname.search("idDominio") != -1) {
      typePayment = "pagopa"
    } else if (payment.module) {
      typePayment = payment.module
    }

    console.log('typePayment: ' , typePayment);

    switch ( typePayment ) {
        
      case "nexi":
        console.log("nexi");                              
        SostaOnlineApiService.nexiOperationResult(parsed)
        .then(data => {                        
          this.setState({paymentResult: data.data, loading: false});   
               
        })
        .catch(err => {
          this.setState({
            paymentResult: {
                TransactionResult: 'KO',
                ErrorCode: 'B2S',
                ErrorDescription: 'Errore di comunicazione con il gateway ('+err.error+')',
                Amount: 0
            }, 
            loading: false
          })
        });
      break;

      case "xpay":
        console.log("xpay");                             
        SostaOnlineApiService.xpayOperationResult(parsed)
          .then(data => {                        
            this.setState({
              paymentResult: data.data,
              loading: false
            });
            }
          )
          .catch(err => {                    
            this.setState({
              paymentResult: {
                TransactionResult: 'KO',
                ErrorCode: 'B2S',
                ErrorDescription: 'Errore di comunicazione con il gateway ('+err.error+')',
                Amount: 0
              }, 
              loading: false
            })                  
          });
          
      break;
          
      case "sella":
          console.log("sella");
          SostaOnlineApiService.decryptSellaOperationResult(parsed.a, parsed.b)
          .then(data => {                    
              this.setState({paymentResult: data.data, loading: false});
              
          }).catch(err => {
              this.setState({paymentResult: {
                  TransactionResult: 'KO',
                  ErrorCode: 'B2S',
                  ErrorDescription: 'Errore di comunicazione con il gateway ('+err.error+')',
                  Amount: 0
              }, loading: false})
          });
          break;
      
      case "pagopa":
        SostaOnlineApiService.pagopaOperationResult(iuv)
        .then(data => {                  
          this.setState({paymentResult: {
              esito: data.data.esito,
              TransactionResult: "OK",
              Amount: data.data.Amount
          }, loading: false}); 
        })
        .catch(err => {          
          this.setState({paymentResult: {
              TransactionResult: 'KO',
              ErrorCode: 'B2S',
              ErrorDescription: 'Errore di comunicazione con il gateway (' + err.error + ')',
              Amount: 0
          }, loading: false})
        });

      break;

      case "pagopaapirest": {

        console.log('pagopapirest');

        const queryString = window.location.href.substring(window.location.href.indexOf('?'));
        const urlParams = new URLSearchParams(queryString);
        const params = Object.fromEntries(urlParams.entries());

         console.log('params: ' , params);
        
        SostaOnlineApiService.pagopaOperationResult(iuv, params)
        .then(data => {                  
          this.setState({paymentResult: {
              esito: data.data.esito,
              TransactionResult: "OK",
              Amount: data.data.Amount
          }, loading: false}); 
        })
        .catch(err => {          
          this.setState({paymentResult: {
              TransactionResult: 'KO',
              ErrorCode: 'B2S',
              ErrorDescription: 'Errore di comunicazione con il gateway (' + err.error + ')',
              Amount: 0
          }, loading: false})
        });

      break;
      }


            
      default:
        if (parsed.IuvCode) {
          console.log('IUV PRESENTE !!!')
        }
      break; 
    }
    
  }

  render() {        
    if(this.state.loading) {
      return(<Loading/>)
    }
    if (this.state.paymentResult ) {
      return (<PaymentResult result={this.state.paymentResult} error={this.state.error} />);
    }
  }
}

PaymentResultContainer.propTypes = {};

export default connect(mapStateToProps, mapDispatchToProps)(PaymentResultContainer);

